import styled from 'styled-components';

export const HelperText = styled.p`
  font-size: 14px;
`;
